import {createSelector} from 'reselect';

import {selectThreadById} from './select_thread_by_id';

export const getLastViewedAtByThreadId = createSelector(selectThreadById, (thread) => thread?.last_viewed_at || 0);
